export default {
  appIcon: require("./app-icon.png"),
  logo: require("./logo.png"),
};
